import { ORGANIZATION_SETTINGS_ROUTE } from "../routes.definitions";

export const GENERAL_SETTINGS_ROUTE = {
  TITLE: "General Settings",
  KEY: "general-settings",
  ABSOLUTE_PATH: `${ORGANIZATION_SETTINGS_ROUTE.ABSOLUTE_PATH}/general-settings`,
};
